import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

type Theme = "dark" | "light";
type IThemeContext = { theme: Theme; onThemeChange: (theme: Theme) => void };
const ThemeContext = createContext<IThemeContext>({} as IThemeContext);

export const useThemeContext = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }: { children?: ReactNode }) => {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem("theme") as Theme) || "dark",
  );

  const handleThemeChange = (theme: Theme) => {
    setTheme(theme);
  };

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, onThemeChange: handleThemeChange }}>
      {children}
    </ThemeContext.Provider>
  );
};
